export default [
  'PAFM00',
  'PAFT00',
  'PAHM00',
  'PAFT10',
  'PDEM10',
  'PDET10',
  'PDEM30',
  'horee',
  'PEDM00',
  'fussi',
  'PEEM00',
  'fluorite',
  'PEEM00',
  'luwu',
  'PFFM10',
  'baize',
  'PFEM10',
  'diting',
  'PFFM20',
  'luna',
  'PGFM10',
  'wukong',
  'PGEM10',
  'nvwa-v',
  'PHZ110',
  'pangu',
  'PHY110',
  'PHY120',
  'yala',
  'PKB110',
  'konka',
  'PKC110',
  'PKC130',
  'koktokay',
  'PKT110',
  'slmh',
  'PLB110',
  'zhufeng',
  'PKJ110',
  'PKU110',
  'PLJ110',
  'PLG110',
  'PLG120',
  'peacock',
  'PEUM00',
  'whiteswan',
  'PGU110',
  'dragonfly',
  'PGT110',
  'xueying',
  'PHN110',
  'flamingo',
  'PHT110',
  'petrel',
  'PKH110',
  'PKH120',
  'PCAM00',
  'PCAT00',
  'PCCM00',
  'PCCT00',
  'PCDM10',
  'PCDT10',
  'PCKM00',
  'PCKT00',
  'PCKM80',
  'PCKT80',
  'PDCM00',
  'PDCT00',
  'PCRM00',
  'PCRT00',
  'PCLM50',
  'PCRT01',
  'PDPM00',
  'PDPT00',
  'PDNM00',
  'PDNT00',
  'PEAM00',
  'PEAT00',
  'kunlun',
  'PEGM00',
  'PEGT00',
  'wudang',
  'PEGM10',
  'PEGT10',
  'chaka',
  'PDSM00',
  'PDST00',
  'hima',
  'PDRM00',
  'garen',
  'PEQM00',
  'yasuo',
  'PEPM00',
  'jin',
  'PENM00',
  'libai',
  'PFJM10',
  'mozi',
  'PFDM00',
  'PFCM00',
  'ali',
  'PGBM10',
  'wuyi',
  'PGAM10',
  'taibai',
  'PFZM10',
  'lantian',
  'PHM110',
  'linhai',
  'PGX110',
  'lvzhou',
  'PGW110',
  'taylor',
  'PHW110',
  'viven',
  'PHV110',
  'monroe',
  'PHU110',
  'huahai',
  'PJH110',
  'daoxiang',
  'PJJ110',
  'omega',
  'omega-c1',
  'PJV110',
  'omega',
  'omega-c1',
  'PJW110',
  'milkyway',
  'milkyway-c2',
  'PKM110',
  'milkyway',
  'milkyway-c1',
  'PKK110',
  'zhuque',
  'zhuque-c2',
  'PLA110',
  'zhuque',
  'zhuque-c1',
  'PKZ110',
  'PLW110',
  'PLV110',
  'PMD110',
  'PCLM10',
  'PDHM00',
  'PACM00',
  'PACT00',
  'PAAM00',
  'PAAT00',
  'PBCM10',
  'PBCT10',
  'PBEM00',
  'PBET00',
  'PBDM00',
  'PBDT00',
  'PADM00',
  'PADT00',
  'PBAM00',
  'PBBM30',
  'PBAT00',
  'PBBT30',
  'PBFM00',
  'PBFT00',
  'PBBM00',
  'PBBT00',
  'PCDM00',
  'PCDT00',
  'PDBM00',
  'PDBT00',
  'PCAM10',
  'PCAT10',
  'PCEM00',
  'PCET00',
  'PCHM10',
  'PCHT10',
  'PCHM30',
  'PCHT30',
  'PCHM00',
  'PCHT00',
  'PDVM00',
  'PDVM00',
  'PEFM00',
  'PESM10',
  'PDAM10',
  'PDAT10',
  'PECM20',
  'PECM30',
  'PECT30',
  'PEMM00',
  'PEMM20',
  'PEMT00',
  'PEMT20',
  'PEMM00',
  'PFVM10',
  'PFTM20',
  'PFTM20',
  'PHJ110',
  'PHJ110',
  'PDYM20',
  'PDYT20',
  'PDYM10',
  'PCPM00',
  'PCPT00',
  'PDKM00',
  'PDKT00',
  'PEHM00',
  'PEHT00',
  'odin-a',
  'PFGM00',
  'PELM00',
  'PFUM10',
  'PHA120',
  'PFTM10',
  'PHS110',
  'hepburn',
  'PHQ110',
  'PHJ110',
  'fanli',
  'PJB110',
  'PJU110',
  'PJS110',
  'givenchy',
  'PJG110',
  'PKA110',
  'PKD110',
  'PKD120',
  'PKD130',
  'PKL110',
  'PJY110',
  'PKQ110',
  'PKV110',
  'PKW110',
  'alpha',
  'alpha-h',
  'PKP110',
  'PLS120',
  'PLL110',
  'PLN110',
  'PKW120',
  'PBCM30',
  'PCGM00',
  'PCGT00',
  'PCNM00',
  'PCNT00',
  'PCLM50',
  'PERM00',
  'PEXM00',
  'walle',
  'walle-k',
  'PERM10',
  'tiga',
  'PEYM00',
  'apollo-o',
  'PGCM10',
  'PGJM10',
  'eva',
  'PGIM10',
  'oscar-y',
  'PGGM10',
  'ziti',
  'PJC110',
  'larry',
  'PHF110',
  'PJR110',
  'PKS110',
  'avatar-m',
  'PJT110',
  'PLD110',
  'PLL110',
  'PKV110',
  'knight',
  'PLM110',
  'PLE110',
  'OPD2101',
  'OPD2102',
  'aries',
  'OPD2201',
  'bluey',
  'OPD2301',
  'dunhuang',
  'OPD2405',
  'caihong',
  'OPD2401',
  'erhai',
  'OPD2409',
  'OPD2417',
  'OPD2506',
  'OB19B1',
  'OB19O1',
  'OB19B1',
  'OB19O3',
  'OB19B1',
  'OB19O7',
  'OB19B3',
  'OB19O0',
  'OB19B3',
  'OB19O2',
  'OB19B3',
  'OB19O8',
  'haisenberg',
  'OBB211',
  'OBB213',
  'OR19R1',
  'OWW206',
  'OWW208',
  'OW19W1',
  'OW19W2',
  'OW19W3',
  'maxwell',
  'OWW202',
  'OW20W1',
  'OW20W2',
  'OW20W3',
  'oersted',
  'OWW213',
  'OWW212',
  'OWW211',
  'comet',
  'huixing',
  'OWW221',
  'star',
  'hengxing',
  'OWW231',
  'sport',
  'OWW235',
  'xingchen',
  'OWW242',
  'starriver',
  'xinghe',
  'OWW251',
  'OWW262',
]